import {
    MEDIATOR_DATA,
    MEDIATOR_SELECTION, EDIT_MEDIATOR, DELETE_MEDIATOR,
    NEW_MEDIATOR, CLEAN_MEDIATOR,
    MEDIATORS_COUNT, MEDIATOR_LOCKED_STATUS,

} from "../../constants/Tabs-Action-Types";
import utils from "../../../utils/utils";
import Constants from "../../../utils/constants";


const initialState = {
    initiateMediatorData:[],
    mediatorData:[],
    selectedMediatorData:[],
    mediatorTableFilter:{},
    mediatorsCount: 0,

};



const mediatorTableDataReducer = (state = initialState, action)=> {

    switch(action.type){

        case MEDIATORS_COUNT: {
            let _idata = JSON.parse(JSON.stringify(action.payload));
            state = {
                ...state,
                mediatorsCount: _idata
            };
            break;
        }
        case MEDIATOR_DATA:
            let collection = []
            action.payload.forEach(mediator =>{
                collection.push({
                    MediatorIndex:mediator.MediatorIndex,
                    MediatorCode:mediator.MediatorCode,
                    MediatorDesc:mediator.MediatorDesc,
                    Enabled:mediator.Enabled?1:0,
                    MediatorMobile:mediator.MediatorMobile,
                    MediatorEmail:mediator.MediatorEmail,
                    SendNotificationToLead:mediator.SendNotificationToLead,
                    SendNotificationToPatient:mediator.SendNotificationToPatient,
                })
            })

            let _pdata = JSON.parse(JSON.stringify(collection));
            state = {
                ...state,
                initiateMediatorData:_pdata,
                mediatorData : _pdata,
                mediatorsCount : collection.length,
            };
            break;
        case CLEAN_MEDIATOR:{
            state = {
                ...state,
                mediatorTableFilter: {},
                selectedMediatorData:[],
                mediatorsCount: 0,
            };
            break;
        }

        case NEW_MEDIATOR: {
            let mediator = action.payload
            let mediatorData = state.mediatorData
            let initiateMediatorData = state.initiateMediatorData
            let newData = [{
                MediatorIndex:mediator.MediatorIndex,
                MediatorCode:mediator.MediatorCode,
                MediatorDesc:mediator.MediatorDesc,
                Enabled:1,
                MediatorMobile:mediator.MediatorMobile,
                MediatorEmail:mediator.MediatorEmail,
                SendNotificationToLead:mediator.SendNotificationToLead,
                SendNotificationToPatient:mediator.SendNotificationToPatient,
            }]

            let newmediatorData = mediatorData.concat(newData)
            let newinitiateMediatorData = initiateMediatorData.concat(newData)

            let _pdata = JSON.parse(JSON.stringify(newmediatorData));
            let _idata = JSON.parse(JSON.stringify(newinitiateMediatorData));
            state = {
                ...state,
                initiateMediatorData:_idata,
                mediatorData : _pdata,
                mediatorsCount: newmediatorData.length,
            };
            break;
        }
        case MEDIATOR_LOCKED_STATUS: {
            let mediator = action.payload
            let mediatorData = state.mediatorData
            let initiateMediatorData = state.initiateMediatorData

            let indexData = mediatorData.findIndex((obj => obj.MediatorIndex === mediator.MediatorIndex));
            let indexInit = initiateMediatorData.findIndex((obj => obj.MediatorIndex === mediator.MediatorIndex));

            let Enabled = mediator.Enabled?1:0

            mediatorData[indexData]['Enabled'] = Enabled
            initiateMediatorData[indexInit]['Enabled'] = Enabled


            let _pdata = JSON.parse(JSON.stringify(mediatorData));
            let _idata = JSON.parse(JSON.stringify(initiateMediatorData));
            state = {
                ...state,
                initiateMediatorData:_idata,
                mediatorData : _pdata,
                mediatorsCount: initiateMediatorData.length,
            };
            break;
        }

        case DELETE_MEDIATOR: {
            let mediator = action.payload
            let mediatorData = state.mediatorData
            let initiateMediatorData = state.initiateMediatorData

            let indexData = mediatorData.findIndex((obj => obj.MediatorIndex === mediator));
            let indexInit = initiateMediatorData.findIndex((obj => obj.MediatorIndex === mediator));


            if(indexData >=0){
                mediatorData.splice(indexData, 1)
            }
            if(indexInit >=0){
                initiateMediatorData.splice(indexInit, 1)
            }


            let _pdata = JSON.parse(JSON.stringify(mediatorData));
            let _idata = JSON.parse(JSON.stringify(initiateMediatorData));
            state = {
                ...state,
                initiateMediatorData:_idata,
                mediatorData : _pdata,
                mediatorsCount: initiateMediatorData.length,

            };
            break;
        }
        case EDIT_MEDIATOR: {
            let mediator = action.payload
            let mediatorData = state.mediatorData
            let initiateMediatorData = state.initiateMediatorData

            let indexData = mediatorData.findIndex((obj => obj.MediatorIndex === mediator.MediatorIndex));
            let indexInit = initiateMediatorData.findIndex((obj => obj.MediatorIndex === mediator.MediatorIndex));

            mediatorData[indexData]['MediatorCode'] = mediator.MediatorCode
            mediatorData[indexData]['Enabled']= mediator.Enabled
            mediatorData[indexData]['MediatorDesc']= mediator.MediatorDesc
            mediatorData[indexData]['MediatorMobile']= mediator.MediatorMobile
            mediatorData[indexData]['MediatorEmail']= mediator.MediatorEmail
            mediatorData[indexData]['SendNotificationToLead']= mediator.SendNotificationToLead
            mediatorData[indexData]['SendNotificationToPatient']= mediator.SendNotificationToPatient


            initiateMediatorData[indexInit]['MediatorCode'] = mediator.MediatorCode
            initiateMediatorData[indexInit]['Enabled']= mediator.Enabled
            initiateMediatorData[indexInit]['MediatorDesc']= mediator.MediatorDesc
            initiateMediatorData[indexData]['MediatorMobile']= mediator.MediatorMobile
            initiateMediatorData[indexData]['MediatorEmail']= mediator.MediatorEmail
            initiateMediatorData[indexData]['SendNotificationToLead']= mediator.SendNotificationToLead
            initiateMediatorData[indexData]['SendNotificationToPatient']= mediator.SendNotificationToPatient

            let _pdata = JSON.parse(JSON.stringify(mediatorData));
            let _idata = JSON.parse(JSON.stringify(initiateMediatorData));
            state = {
                ...state,
                initiateMediatorData:_idata,
                mediatorData : _pdata,
                mediatorsCount: initiateMediatorData.length,
            };
            break;
        }

        default:
            break;
    }
    return state;
};
export default mediatorTableDataReducer;
